import jwtwebtoken from 'jsonwebtoken'
window.jwtwebtoken = jwtwebtoken

// 提取url中的解析参数
window.QueryDict = (function () {
  var searchstr = window.location.search;
  if (!searchstr) return {};
  var str = window.location.search.split("?")[1];
  var items = str.split("&");
  var dict = {};

  for (var i = 0, l = items.length; i < l; i++) {
    var arr = items[i].split("=");
    var name = arr[0];
    var value = arr[1];
    dict[name] = value;
  }
  return dict;
})();

window.topbashhost = window.QueryDict["topbashhost"];

window.core_hookRelogin = function (method) {
  window.$app.store.commit("core/setRelogin");
  window.$app.store.commit("core/setReloginRefresh", method === "get");
};

window.core_hooklogout = function () {
  if (window.$app.safelogout)
    window.$app.safelogout()
  else
    window.$app.store.dispatch("core/logout")
};


//重新登录
window.core_dlgRelogin = function (isRefresh) {
  window.$app.store.commit("core/setRelogin");
  window.$app.store.commit("core/setReloginRefresh", isRefresh);
}

if (!window.FX_BASE_URL)
  window.FX_BASE_URL = location.pathname.substr(0, location.pathname.lastIndexOf("/"));

// let curlopt = function () {
//   if (!window.FX_BASE_URL)
//     window.FX_BASE_URL = location.pathname.substr(0, location.pathname.lastIndexOf("/"));

//   let result = {};
//   const checkNetUrl = "/api/public/core/checkNet";
//   let xmlHttp = new XMLHttpRequest();
//   // let timeCha = null;
//   // let signsalt = null;
//   window.core_bstimediff = 0;
//   xmlHttp.onreadystatechange = function () {
//     if (xmlHttp.readyState == 4) {
//       let local_t = new Date();
//       let server_t = new Date(xmlHttp.getResponseHeader("date"));
//       window.core_bstimediff = server_t.getTime() - local_t.getTime();
//       window.FX_LAST_MODIFIED = xmlHttp.getResponseHeader("fxlastmodified");
//       // result = {
//       //   stime: server_t.getTime() - local_t.getTime(), //计算时间差
//       //   signsalt: xmlHttp.getResponseHeader("signsalt"),
//       // };
//     }
//   };
//   xmlHttp.open("get", window.FX_BASE_URL + checkNetUrl, false); // 这里使用同步
//   xmlHttp.send();
//   return result;
// }()


export default {

  async exec(app) {
    let { curl, io } = app

    /*
    await app.socketAPI.sendMessage(userid, {
      type: `fxweboffice-${saveid}-onsave`,
      SendContent: result.data,
    });
    */
    io.on("core-redirect-login", () => {
      // window.core_hooklogout()
      if (window.QueryDict["refererhost"]) {
        location.href = window.QueryDict["refererhost"];
        return
      }
      window.location.href = "./login.html"
    })

    /*
        return
        let { curl, io } = app
        // await curl.get('/api/public/core/checkNet');
        curl.InitSecurityResponseHeaders(window.InitSecurityResponseHeaders_Instance)
        //window.location.protocol+"://"+window.location.host
        let exec_obj = null;
        function exec_iframe(url) {
          if (!window.topbashhost) return;
          if (!exec_obj) {
            exec_obj = document.createElement("iframe");
            exec_obj.name = "tmp_frame";
            exec_obj.src = window.topbashhost + url + "&r=" + new Date().getTime();
            exec_obj.style.display = "none";
            document.body.appendChild(exec_obj); //动态创建一个iframe
          } else {
            exec_obj.src = window.topbashhost + url + "&r=" + new Date().getTime();
          }
        }
    
        function InIFrame() {
          return window.self.frameElement && window.self.frameElement.tagName == "IFRAME";
        }
    
        let errorfunc = (error) => {
          const status = error.response.status;
          const data = error.response.data || {};
          const errorUrl = error.response.request.responseURL;
          const errorMethod = error.response.config.method.toUpperCase();
          if (status === 401) {
            app.emitDirection = true;
            let { core } = app.store.state;
    
            if (InIFrame()) {
              try {
                top.window.core_hookRelogin(error.response.config.method);
              } catch (error) {
                exec_iframe(`/iframe/relogin.html?method=${error.response.config.method}&r=${new Date().getTime()}`);
              }
              return;
            }
    
            if (core && core.user && core.user.username) {
              window.core_hookRelogin(error.response.config.method);
              return;
            } else {
              //如果登录失败会记录存储url，作用在下去登录成功后重定向的地址
              let url = window.location.href || ''
              sessionStorage.setItem("core_redirect", url);
              location.href = "login.html";
            }
          } else {
            if (error.response.config.headers["core_msgalert"] == "false") return;
            else if (error.response.headers["core_msgalert"] == "false") return;
    
    
    
            let isFold = false;
            let obj = { isFold: false };
            let msg = "";
            if (data.message) msg = error.response.data.message;
            else msg = error.message;
    
            if (status === 505) {
              app.Vue.prototype.$Message.error(`校验出错:${data.msg}`);
              return;
            }
            if (status === 506) {
              app.Vue.prototype.$Message.error(data.msg);
              return;
            }
    
            // if (status === 404) {
    
            // }
    
            if (data.stack) {
              app.Vue.prototype.$Message.message("", {
                duration: 0,
                closable: true,
                render: (h) =>
                  h(
                    "div",
                    {
                      style: {
                        textAlign: "left",
                        maxHeight: "300px",
                        overflow: "auto",
                      },
                    },
                    [h("pre", data.stack)]
                  ),
              });
            } else {
              const pAttr = {
                style: {
                  lineHeight: "1.25",
                  wordBreak: "break-word",
                },
              };
              app.Vue.prototype.$Notice.warning({
                duration: 5000,
                title: "服务端异常，请联系运维人员",
                render: (h) =>
                  h("div", [
                    h(
                      "p",
                      {
                        class: "fx__text_link",
                        style: {
                          lineHeight: "1.25",
                          wordBreak: "break-word",
                          margin: "20px 0 10px 0",
                          cursor: " pointer",
                          "-webkit-user-select": "none",
                          "-moz-user-select": "none",
                          "-ms-user-select": "none",
                          "user-select": "none",
                        },
                        on: {
                          click: (sender) => {
                            if (!sender.currentTarget.isopen) {
                              sender.currentTarget.nextSibling.style.display = "block";
                              sender.currentTarget.isopen = true;
                            } else {
                              sender.currentTarget.nextSibling.style.display = "none";
                              sender.currentTarget.isopen = false;
                            }
                          },
                        },
                      },
                      `详情信息`
                    ),
                    h(
                      "div",
                      {
                        class: {},
                        style: {
                          display: "none",
                        },
                      },
                      [h("h3", pAttr, `${status}  ${msg}`), h("p", pAttr, `Method:${errorMethod}`), h("p", pAttr, `URL:${errorUrl}`)]
                    ),
                  ]),
              });
              // app.Vue.prototype.$Notice.warning({
              //   duration: 5000,
              //   title: status + ' ' + msg,
              //   render: h => h("div",
              //     [
              //       h("p", pAttr, `Method:${errorMethod}`),
              //       h("p", pAttr, `URL:${errorUrl}`),
              //       h("p", {
              //         style: {
              //           lineHeight: "1.25",
              //           wordBreak: 'break-word',
              //           color:' rgb(80, 78, 78)',
              //           'font-weight': 'bold',
              //           'margin-top':'5px'
    
              //         }
              //       }, `请联系运维人员`)
              //     ])
              // });
            }
            return;
          }
        };
    
        let repfunc = (response) => {
          let {
            config: { url },
            headers,
          } = response;
    
          // if (url.startsWith("/api/notify")) {
          //   let local_t = new Date();
          //   let server_t = new Date(headers["date"]);
          //   window.notify_timecha = server_t - local_t;
          // }
    
          return response.data;
        };
    
        curl.interceptors.response.useEx(repfunc, errorfunc);
    */
    // return { curl, io }
  }
};
